import { FC } from 'react';
import PriceSetting from './PriceSetting';
import UsePriceSetting from './UsePriceSetting';

const PriceSettingContainer: FC = () => {
  return <PriceSetting {...UsePriceSetting()} />;
};

export default PriceSettingContainer;
